// type 1: choice; 2: range; 3: string (ZCam docs)
export const RECORDING_SETTINS = Object.freeze({
    INT_RECORD: {
        title: 'INT Record',
        key: 'resolution',
        type: 1,
        defaultValue: '1920x1080',
        options: [
            '1920x1080',
            '4K',
            'C4K (Low Noise)',
            '4K (Low Noise)',
            'C4K',
            'C4K 2.4:1',
            '4K 2.4:1',
            '3696x2772 (Low Noise)',
            '3696x2772',
            '3312x2760',
            'S16',
            'S16 16:9'
        ],
    },
    INT_FPS: {
        title: 'INT FPS',
        key: 'project_fps',
        type: 1,
        defaultValue: '29.97',
        options: [
            '23.98',
            '24',
            '25',
            '29.97',
            '50',
            '59.94'
        ],
    },
    INT_CODEC: {
        title: 'INT Codec',
        key: 'video_encoder',
        type: 1,
        defaultValue: 'H.264',
        options: [
            'H.264',
            'H.265',
            'ProRes 422 Proxy',
            'ProRes 422 LT',
            'ProRes 422',
            'ProRes 422 HQ'
        ],
    },
});

export const WHITE_BALANCE_SETTINGS = Object.freeze({
    WHITE_BALANCE: {
        title: 'WB',
        key: 'mwb',
        type: 2,
        defaultValue: 2800,
        min: 2300,
        max: 30000,
        step: 100,
    },
    TINT: {
        title: 'Tint',
        key: 'tint',
        type: 2,
        defaultValue: 0,
        min: -100,
        max: 100,
        step: 1,
    },
});

export const IMAGE_SETTINGS = Object.freeze({
    CONTRAST: {
        title: 'Contrast',
        key: 'contrast',
        type: 2,
        defaultValue: 50,
        min: 0,
        max: 100,
        step: 1,
    },
    BRIGHTNESS: {
        title: 'Brightness',
        key: 'brightness',
        type: 2,
        defaultValue: 50,
        min: 0,
        max: 100,
        step: 1,
    },
    SATURATION: {
        title: 'Saturation',
        key: 'saturation',
        type: 2,
        defaultValue: 50,
        min: 0,
        max: 100,
        step: 1,
    },
    PROFILE: {
        title: 'Profile',
        key: 'lut',
        type: 1,
        defaultValue: 'Rec.709',
        options: [
            'Rec.709',
	        'HLG',
            'Z-Log2',
            'Flat',
            'Concert',
            'Vivi 0',
            'Vivi 1',
            'Vivi 2'
        ]
    },
});

export const EXPOSURE_SETTINGS = Object.freeze({
    ISO: {
        title: 'ISO',
        key: 'iso',
        type: 1,
        defaultValue: 'Auto',
        options: [
            'Auto',
            '500',
            '640',
            '800',
            '1000',
            '1250',
            '1600',
            '2000',
            '2500',
            '3200',
            '4000',
            '5000',
            '6400',
            '8000',
            '10000',
            '12800',
            '16000',
            '20000',
            '25600',
            '32000',
            '40000',
            '51200',
            '64000',
            '80000',
            '102400'
        ]
    },
    F_STOP: {
        title: 'F Stop',
        key: 'iris',
        type: 1,
        defaultValue: '16',
        options: [
            '2.8',
            '3.2',
            '3.5',
            '4',
            '4.5',
            '5',
            '5.6',
            '6.3',
            '7.1',
            '8',
            '9',
            '10',
            '11',
            '13',
            '14',
            '16',
            '18',
            '20',
            '22'
        ]
    },
    SHUTTER: {
        title: 'Shutter',
        key: 'shutter_angle',
        type: 1,
        defaultValue: 'Auto',
        options: [
            'Auto',
            '1°',
            '2°',
            '4°',
            '5°',
            '8°',
            '10°',
            '11.25°',
            '15°',
            '22.5°',
            '30°',
            '37.5°',
            '45°',
            '60°',
            '72°',
            '75°',
            '90°',
            '108°',
            '120°',
            '144°',
            '150°',
            '172.8°',
            '180°',
            '216°',
            '270°',
            '324°',
            '360°'
        ]
    },
});